import { useQuery } from 'react-query'
import { PBF_QUERY_KEY } from '@/constant/pbf'
import { getCompanySetting } from '@/screens/SystemConfigure/UserManagment/UserManagment.transform'
import { COMPANY_SETTING_HAS_MEASUREMENT_AQL } from '@/constant/user'
import { getAQLPropertyValues } from '@/screens/SystemConfigure/DataManagment/DataManagement.service'
import { IsJsonString } from '@/utils/common'

export function useHasMeasurementAql() {
  const { data: companySettingMeasurementAql } = useQuery(
    [PBF_QUERY_KEY.GET_COMPANY_SETTING_MEASUREMENT_AQL],
    async () => {
      return await getCompanySetting('', COMPANY_SETTING_HAS_MEASUREMENT_AQL)
    }
  )
  return companySettingMeasurementAql?.value?.status
}

export function useAqlOptions(aqlType: 'measurement' | 'default', enabled: boolean = true) {
  return useQuery(
    [PBF_QUERY_KEY.GET_AQL_LIST, aqlType],
    async () => {
      const res = await getAQLPropertyValues(aqlType)
      const items = res.data?.data?.data || res.data?.data || []
      const arrayToMap = Array.isArray(items) ? items : []

      return arrayToMap.map((item: any) => ({
        label: IsJsonString(item.value) ? JSON.parse(item.value)?.name : item.value,
        is_default: item?.is_default,
        value: item.id,
      }))
    },
    {
      enabled,
    }
  )
}
